import { meta } from '@/helpers/constants/router';
import { ECOMMERCE_ORDER_MENU_KEY } from '@/helpers/constants/app';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Wrapper = () => import('@/views/Wrapper.vue');
export default [
    {
        path: 'overview',
        component: Wrapper,
        meta: { ...meta, title: 'Overview' },
        children: [
            {
                path: 'sales-funnel',
                component: Wrapper,
                meta: {
                    title: 'Overview',
                    redirect: 'distributor-overview',
                },
                children: [
                    {
                        path: '/',
                        name: 'distributor-sales-funnel',
                        component: () => import('@/views/v2/ecommerce/SalesFunnel.vue'),
                        meta: {
                            title: 'Sales Funnel',
                        },
                    },
                ],
            },
            {
                path: '/',
                component: Wrapper,
                meta: {
                    title: 'Overview',
                    redirect: 'distributor-overview',
                },
                children: [
                    {
                        path: '/',
                        name: 'distributor-overview',
                        component: () => import('@/views/v2/ecommerce/Overview.vue'),
                        meta: {
                            title: 'Overview',
                        },
                    },
                    {
                        path: 'latest-sold-products',
                        name: 'distributor-sold-products',
                        component: () => import('@/components/v2/ecommerce/LatestSoldProductsIndex.vue'),
                        meta: { title: `Today's Latest Sold Products` },
                    },
                    {
                        path: 'sales-amount',
                        name: 'distributor-sales-amount',
                        component: () => import('@/components/v2/ecommerce/SalesAmountIndex.vue'),
                        meta: { title: `Today's Sales Amount` },
                    },
                    {
                        path: 'latest-customers',
                        name: 'distributor-latest-customers',
                        component: () => import('@/components/v2/ecommerce/LatestCustomersIndex.vue'),
                        meta: { title: `Today's Latest Customers` },
                    },
                ],
            },
            {
                path: 'performance',
                component: Wrapper,
                meta: {
                    title: 'In-App Store Performance',
                    redirect: 'distributor-performance',
                },
                children: [
                    {
                        path: '/',
                        name: 'distributor-performance',
                        component: () => import('@/views/v2/ecommerce/Performance.vue'),
                        meta: {
                            title: 'In-App Store Performance',
                        },
                    },
                    {
                        path: 'popular-producs',
                        name: 'distributor-popular-products',
                        component: () => import('@/views/v2/ecommerce/PopularProductList.vue'),
                        meta: {
                            title: 'Most Viewed Products',
                            parentMenu: 'distributor-performance',
                        },
                    },
                    {
                        path: 'most-sold-producs',
                        name: 'distributor-profitable-products',
                        component: () => import('@/views/v2/ecommerce/ProfitableProductList.vue'),
                        meta: {
                            title: 'Most Sold Products',
                            parentMenu: 'distributor-performance',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: 'orders',
        component: Wrapper,
        redirect: 'orders-by-status',
        meta: { ...meta, title: 'Orders' },
        children: [
            {
                path: 'history',
                name: 'distributor-order-history',
                meta: { title: 'Order History', parentMenu: ECOMMERCE_ORDER_MENU_KEY },
                props: true,
                component: () => import('@/views/v2/ecommerce/OrderHistory.vue'),
            },
            {
                path: ':status/:filter?',
                component: () => import('@/views/v2/ecommerce/Orders.vue'),
                children: [
                    {
                        path: '/',
                        name: 'distributor-orders-by-status',
                        meta: { title: 'Order Tracker', parentMenu: ECOMMERCE_ORDER_MENU_KEY },
                        props: true,
                        component: () => import('@/views/v2/ecommerce/OrdersByStatus.vue'),
                    },
                ],
            },
        ],
    },
];
